// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
import * as helper from "./helper";
import {createRoot} from 'react-dom/client';
import {Layout} from './Layout';
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import {data} from './Store/Data';
// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
    require('babel-polyfill');
}

helper.onDocumentLoaded(() => {
    const footerEl = helper.$('#footer') as HTMLElement;

    const language = data("lang").asString() || "de";
    const App = () => <Layout/>;
    const root = createRoot(document.getElementById('root') as HTMLElement);
    i18n.use(initReactI18next).init({
        lng: language,
        fallbackLng: language,
        interpolation: {
            escapeValue: false,
            prefix: "{{",
            suffix: "}}",
        },
        backend: {},
    });

    fetch("/Localisation/" + language.toUpperCase() + "/translation.json")
        .then((response) => response.json())
        .then((data) => i18n.addResourceBundle(language, "translation", data))
        .then(() => root.render(<App/>))
        .then(() => footerEl.hidden = false);
});
